module.exports = __webpack_public_path__ + "img/5_83.6e67e097.png";